import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class HomeSearch extends React.PureComponent {
    state = {
        searchTxt: '请输入楼盘名/地址',
    };

    handleChange = e => {
        const val = e.currentTarget.value;

        this.setState({ searchTxt: val });
    };

    handleKeydown = e => {
        const val = e.currentTarget.value ? e.currentTarget.value : '';

        if (e.keyCode === 13) window.open(`http://house.ifeng.com/search?keyword=${val}`);
    };

    handleFocus = e => {
        const val = e.currentTarget.value;

        this.setState({
            searchTxt: val === '请输入楼盘名/地址' ? '' : val,
        });
    };

    handleBlur = e => {
        const val = e.currentTarget.value;

        this.setState({
            searchTxt: val === '' ? '请输入楼盘名/地址' : val,
        });
    };

    handleClick = e => {
        const val =
            e.currentTarget.attributes['txt'].value !== '请输入楼盘名/地址'
                ? e.currentTarget.attributes['txt'].value
                : '';

        window.open(`http://house.ifeng.com/search?keyword=${val}`);
    };

    render() {
        const { searchTxt } = this.state;

        return (
            <div className={styles.auto_search}>
                <span>
                    <input
                        className={styles.txt}
                        type="text"
                        value={searchTxt}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeydown}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                </span>
                <span>
                    <input className={styles.btn} type="button" txt={searchTxt} onClick={this.handleClick} />
                </span>
            </div>
        );
    }
}

export default errorBoundary(HomeSearch);
